import React from 'react';
import { Button } from './ui/button';
import { ChevronRight, Calendar } from 'lucide-react';

export const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center section-full overflow-hidden">
      {/* Background Image - mobile and desktop variants */}
      <div
        className="absolute inset-0 z-0 md:hidden"
        style={{
          backgroundImage: 'url(/hero-camden-dawn.webp)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-transparent"></div>
      </div>
      <div
        className="absolute inset-0 z-0 hidden md:block"
        style={{
          backgroundImage: 'url(/hero-camden-scenic-desktop.webp)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-transparent"></div>
      </div>

      {/* Content */}
      <div className="container-wide relative z-10 py-24 sm:py-32 px-4 sm:px-6">
        <div className="max-w-4xl animate-fade-in-up">
          {/* Date Badge */}
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-md border border-white/20 px-3 sm:px-4 py-2 mb-6 sm:mb-8">
            <Calendar className="text-white" size={16} />
            <span className="text-white font-bold text-xs sm:text-sm uppercase tracking-wider">Sunday 26th July 2026</span>
          </div>
          
          {/* Main Title */}
          <h1 className="display-title text-5xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-[10rem] text-white mb-4 sm:mb-6" style={{ lineHeight: '0.9' }}>
            CAMDEN
            <br />
            WAS MADE
            <br />
            TO RUN
          </h1>
          
          {/* Subtitle */}
          <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl text-white font-light leading-relaxed mb-6 sm:mb-8 max-w-2xl">
            Experience an unforgettable day of running through beautiful Camden
          </p>
          
          {/* Elite Energy Logo */}
          <div className="mb-8 sm:mb-10">
            <img 
              src="https://customer-assets.emergentagent.com/job_festival-prototype/artifacts/8g7i3uly_Elite-Energy-Reversed.svg" 
              alt="Elite Energy" 
              className="h-16 sm:h-20 md:h-24 w-auto opacity-90"
            />
          </div>
          
          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
            <Button className="btn-hero-primary group">
              Register Now
              <ChevronRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
            </Button>
            <Button className="btn-hero-secondary">
              View Races
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
